import React from "react";
import "../App.css";

export default function PageArea({ children }) {
  return <div className="pagearea">{children}</div>;
}
